export default __webpack_public_path__ + "static/media/Auto Shot Blast Machine.7ef98416.jpg";